module.exports = "<select2 class=\"select-locale\" [data]=\"locales\" (update)=\"setLocale($event)\"></select2>\n"